<div id="content" class="without-subnavbar allcp-form" ng-controller="AccountController" ng-init="init()">
    <div ng-include="'modules/company/menus/setting_menu.html'"></div>
    <div class="panel-body">

        <h5>My Profile</h5>
        <hr>
        <form class="form-horizontal" ng-submit="updateUserInfo()">
            <div class="row">
                <div class="col-md-8">
                    
                    <div class="form-group floating">
                        <input type="text" placeholder="First Name" class="form-control input-md" ng-model="user.first_name">
                        <label>First Name</label>
                    </div>
            
                    <div class="form-group floating">
                        <input type="text" placeholder="Last Name" class="form-control input-md" ng-model="user.last_name">
                        <label>Last Name</label>
                    </div>

                    <div class="form-group floating">
                        <input type="email" placeholder="Email" class="form-control input-md" ng-model="user.email" disabled="true">
                        <label>Email</label>
                    </div>

                    <div class="form-group">
                        <button type="submit" class="btn btn-primary">Update</button>
                    </div>

                </div>
            </div>
        </form>
        <h5>Company Info</h5>
        <hr>
        <form class="form-horizontal" ng-submit="updateCompanyInfo()">
            <div class="row">
                <div class="col-md-8">
                    <div class="form-group floating">
                        <input type="text" placeholder="Company Name" 
                            ng-disabled="!authenticatedUser.owner" 
                            class="form-control input-md" ng-model="company.name">
                        <label>Company Name</label>
                    </div>

                    <div class="form-group floating">
                        <input type="email" placeholder="Email" 
                            ng-disabled="!authenticatedUser.owner" 
                            class="form-control input-md" ng-model="company.email">
                        <label>Email</label>
                    </div>

                    <div class="form-group floating">
                        <input type="text" placeholder="Phone Number" 
                            ng-disabled="!authenticatedUser.owner" 
                            class="form-control input-md" ng-model="company.phone">
                        <label>Phone Number</label>
                    </div>

                    <div class="form-group floating">
                        <input type="text" placeholder="Mobile Phone Number" 
                            ng-disabled="!authenticatedUser.owner" 
                            class="form-control input-md" ng-model="company.mobile_phone">
                        <label>Mobile Phone Number</label>
                    </div>

                    <div class="form-group" ng-if="authenticatedUser.owner" >
                        <button type="submit" class="btn btn-primary">Update</button>
                    </div>

                </div>
                <div class="col-md-3" style="height: 360px;">
                    <div class="fileupload fileupload-new" data-provides="fileupload">
                        <div class="fileupload-preview thumbnail">
                            <img ng-if="company.logo" 
                                class="img-responsive center" 
                                style="height:140px"
                                ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ company.logo }}" />
                            <i ng-if="!company.logo" class="icon-drag-icon"></i>
                            <p>Drag logo here</p>
                            <div class="line-seperator">
                                <div class="line"></div>
                                <p>OR</p>
                                <div class="line"></div>
                            </div>
                            <div class="logo_upload" ng-repeat="item in logo.queue" style="width:50%">
                                <div class="progress" ng-if="proccessProfile">
                                    <div 
                                        class="progress-bar progress-bar-success progress-bar-striped active" 
                                        role="progressbar" 
                                        aria-valuenow="60" 
                                        aria-valuemin="0" 
                                        aria-valuemax="100" 
                                        ng-style="{ 'width': item.progress + '%' }"
                                        >
                                    </div>
                                </div>
                            </div>
                            <span class="btn btn-outline btn-file">
                                <span class="fileupload-new">Select</span>
                                <input type="file" nv-file-select uploader="logo">
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </form>

            <!-- <h5> Fatura Bilgileri</h5>
            <hr>
            <div class="row">
                <div class="col-md-8">
                    <div class="form-group row">
                        <label for="store-name" class="col-md-3 control-label">Şirket Adı:</label>
                        <div class="col-md-9">
                            <label for="store-name" class="field prepend-icon">
                                <input type="text" name="store-name" id="business-name-5" placeholder="Şirket Adı"
                                       class="gui-input" ng-model="company.name">
                                <label for="store-name" class="field-icon">
                                    <i class="fa fa-link"></i>
                                </label>
                            </label>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="store-name" class="col-md-3 control-label">Vergi Numarası :</label>
                        <div class="col-md-9">
                            <label for="store-name" class="field prepend-icon">
                                <input type="text" name="store-name" id="business-name-6" placeholder="Vergi Numarası"
                                       class="gui-input" ng-model="company.tax_number">
                                <label for="store-name" class="field-icon">
                                    <i class="fa fa-link"></i>
                                </label>
                            </label>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="store-name" class="col-md-3 control-label">Vergi Dairesi :</label>
                        <div class="col-md-9">
                            <label for="store-name" class="field prepend-icon">
                                <input type="text" name="store-name" id="business-name-7" placeholder="Vergi Dairesi"
                                       class="gui-input" ng-model="company.tax_office">
                                <label for="store-name" class="field-icon">
                                    <i class="fa fa-link"></i>
                                </label>
                            </label>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="store-desc" class="col-md-3 control-label">Adres:</label>
                        <div class="col-md-9">
                            <label class="field prepend-icon">
                                <textarea class="gui-textarea" id="store-desc" name="store-desc"
                                          ng-model="company.address" placeholder="Adres"></textarea>
                                <label for="store-desc" class="field-icon">
                                    <i class="fa fa-location-arrow"></i>
                                </label>
                            </label>
                        </div>
                    </div>

                    <div class="form-group">
                        <button type="submit" class="btn btn-primary">Güncelle</button>
                    </div>
                </div>
            </div> -->
    </div>
</div>
